import { render, staticRenderFns } from "./ThunderIcon.vue?vue&type=template&id=4a2d4933&scoped=true&"
import script from "./ThunderIcon.vue?vue&type=script&lang=js&"
export * from "./ThunderIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2d4933",
  null
  
)

export default component.exports